import React, { useState } from "react";
import { Link } from "react-router-dom";
import PropTypes from 'prop-types';
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
import { all_routes } from "../router/all_routes";
import { checkUserNameAlready, loginToPortal, sendOtpEmail, sendOtpMobile, verifyOtpMobile } from "../../functionsMaster";
// import ReCAPTCHA from 'react-google-recaptcha';

const routes = all_routes
const Login = ({ message = "", checkIfLoggedIn = async () => { console.log(""); } }) => {
  let redURLLogged = localStorage.getItem('redURLLogged');
  if (!redURLLogged) {
    redURLLogged = "/listings/cars";
  }
  const [resMessage, setResMessage] = useState({ status: 0, value: "" });
  const [formData, setFormData] = useState({
    type: '',  // mobileSignUp emailSignUp mobileLogin emailLogin
    username: '',
    redURLLogged,
    mOtp: '',
    eOtp: '',
    eVerify: false,
    mVerify: false,
    name: '',
    email: '',
    mobile: '',
    gender: '',
    dob: '',
    emailSent: false,
  });

  // for checking if the email or Mobile is already exists

  async function sendMobileOtp(object = {}) {
    const temp = await sendOtpMobile(object);
    setResMessage({ ...resMessage, status: temp.status, value: temp.message });
    return false;
  }

  async function sendEmailOtp(object = {}) {
    const temp = await sendOtpEmail(object);
    setResMessage({ ...resMessage, status: temp.status, value: temp.message });
    return false;
  }

  async function verifyMobileOtp() {
    const temp = await verifyOtpMobile(formData);
    setResMessage({ ...resMessage, status: temp.status, value: temp.message });
    if (temp.status) {
      await loginForUser();
    }
    return false;
  }  

  async function loginForUser() {
    const temp = await loginToPortal(formData);
    setResMessage({ ...resMessage, status: temp.status, value: temp.message });
    if (temp.token) {
      localStorage.setItem('uToken', temp.token);
    }
    if (temp.status) {
      await checkIfLoggedIn();
    }
    return false;
  }

  // for checking if the enter is email or Mobile
  async function submitLoginForm() {
    switch(formData.type) {
      case "mobileLogin":
          await verifyMobileOtp();
        break;
      case "emailLogin":
          await loginForUser();
        break;
      case "mobileSignUp":
          await verifyMobileOtp();
        break;
      case "emailSignUp":
          await loginForUser();
        break;
      default:
        // handleUsernameChange is already work for this case
        break;
    }
    return false;
  }

  const handleUsernameChange = async(e) => {
    if (!e.target.value) {
      setFormData({ ...formData, username: e.target.value });
      return false;
    }
    const value = e.target.value.trim();

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const mobileRegex = /^[6-9]\d{9}$/;

    // eslint-disable-next-line prefer-const
    let updatedData = {
      ...formData,
      type: 'notValid',
      username: value,
      mOtp: '',
      eOtp: '',
      eVerify: false,
      mVerify: false,
      emailSent: false,
    };

    if (emailRegex.test(value)) {
      updatedData.email = value;
      updatedData.mobile = "";
      setResMessage({ ...resMessage, status: 0, value: "" });
    } else if (mobileRegex.test(value)) {
      updatedData.mobile = value;
      updatedData.email = "";
      setResMessage({ ...resMessage, status: 0, value: "" });
    } else {
      updatedData.email = "";
      updatedData.mobile = "";
      updatedData.type = "notValid";
      setFormData(updatedData);
      setResMessage({ ...resMessage, status: 0, value: "Please enter a 0 valid email or 10-digit mobile number." });
      return false;
    }

    if (updatedData.email === updatedData.username || updatedData.mobile === updatedData.username) {
      const AlreadyAccount = await checkUserNameAlready(updatedData);
      setResMessage({ ...resMessage, status: AlreadyAccount.status, value: AlreadyAccount.message });
      updatedData.type = AlreadyAccount.type;
      setFormData(updatedData);
      if (AlreadyAccount.type === "mobileLogin") {
        await sendMobileOtp(updatedData);
      }
      if (AlreadyAccount.type === "mobileSignUp") {
        await sendMobileOtp(updatedData);
      }
      if (AlreadyAccount.type === "emailLogin") {
        await sendEmailOtp(updatedData);
      }
    }
    
  };

  return (
    <div className="main-wrapper login-body">
      <div className="login-wrapper p-5">
        <div className="loginbox">
          <div className="login-auth">
            <div className="login-auth-wrap">
              <h1>Login</h1>
              <p
                className="account-subtitle"
                dangerouslySetInnerHTML={{ __html: message }}
              ></p>
              <form
                method="POST"
                onSubmit={(e) => {
                  e.preventDefault();
                  submitLoginForm();
                }}
              >
                <div className="input-block">
                  <label className="form-label">
                    Email or Mobile <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    defaultValue={formData.username}
                    className="form-control"
                    placeholder="Enter Email or Mobile"
                    required
                    onChange={(e) => {
                      handleUsernameChange(e);
                    }}
                    />
                </div>

                 {(!formData.emailSent && formData.type === "emailSignUp") && (
                  <div className="text-right mb-3">
                    <button
                      className="btn btn-sm btn-info"
                      type="button"
                      onClick={(e) => {
                        e.preventDefault();
                        sendEmailOtp(formData);
                        setFormData({ ...formData, emailSent: true });
                      }}
                    >
                      Send Email OTP
                    </button>
                  </div>
                )}
                 

                {(formData.type === "mobileSignUp" || formData.type === "emailSignUp") && (
                  <>
                    <div className="input-block">
                      <label className="form-label">
                        Your Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        required
                        value={formData.name}
                        className="form-control"
                        placeholder=""
                        onChange={(e) => {
                          setFormData({ ...formData, name: e.target.value });
                        }}
                        />
                    </div>

                    <div className="row">
                      
                      <div className="col-md-6">
                        <div className="input-block">
                          <label className="form-label">
                            Gender
                          </label>
                          <select
                            value={formData.gender}
                            className="form-control"
                            onChange={(e) => {
                              setFormData({ ...formData, gender: e.target.value });
                            }}
                          >
                             <option value="">Select</option> 
                             <option value="Male">Male</option> 
                             <option value="Female">Female</option> 
                          </select>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="input-block">
                          <label className="form-label">
                            Birthday
                          </label>
                          <input
                            type="date"
                            value={formData.dob}
                            className="form-control"
                            placeholder=""
                            onChange={(e) => {
                              setFormData({ ...formData, dob: e.target.value });
                            }}
                            />
                        </div>
                      </div>
                    </div>

                    <div className={`input-block ${formData.type === "mobileSignUp" ? "" : "d-none" }`}>
                      <label className="form-label">
                        Email Address <span className="text-danger">*</span>
                      </label>
                      <input
                        type="email"
                        required
                        value={formData.email}
                        className="form-control"
                        placeholder=""
                        onChange={(e) => {
                          setFormData({ ...formData, email: e.target.value });
                        }}
                        />
                    </div>
                    <div className={`input-block ${formData.type === "emailSignUp" ? "" : "d-none" }`}>
                      <label className="form-label">
                        Mobile Number <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        required
                        value={formData.mobile}
                        className="form-control"
                        placeholder=""
                        onChange={(e) => {
                          setFormData({ ...formData, mobile: e.target.value });
                        }}
                        />
                    </div>
                  </>
                )}

                {(formData.type === "mobileLogin" || formData.type === "mobileSignUp") && (
                  <div className="input-block">
                    <label className="form-label">
                      Mobile OTP <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      required
                      value={formData.mOtp}
                      className="form-control"
                      placeholder=""
                      onChange={(e) => {
                        setFormData({ ...formData, mOtp: e.target.value });
                      }}
                      />
                  </div>
                )}
                
                {(formData.type === "emailLogin" || formData.type === "emailSignUp") && (
                  <div className="input-block">
                    <label className="form-label">
                      Email OTP <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      required
                      value={formData.eOtp}
                      className="form-control"
                      placeholder=""
                      onChange={(e) => {
                        setFormData({ ...formData, eOtp: e.target.value });
                      }}
                      />
                  </div>
                )}

                {resMessage.value !== '' && (
                  <div className={`alert alert-${resMessage.status === 1 ? "success" : "danger"}`}>
                    {resMessage.value}
                  </div>
                )}   
                   
                <button
                  type="submit"
                  className="btn btn-outline-light w-100 btn-size mt-1"
                >
                  Continue
                </button>
                {/* <div className="login-or">
                  <span className="or-line" />
                  <span className="span-or-log">
                    Or, log in with your email
                  </span>
                </div> */}
                {/* Social Login */}
                <div className="social-login d-none">
                  <Link
                    to="#"
                    className="d-flex align-items-center justify-content-center input-block btn google-login w-100"
                  >
                    <span>
                      <ImageWithBasePath
                        src="assets/img/icons/google.svg"
                        className="img-fluid"
                        alt="Google"
                      />
                    </span>
                    Log in with Google
                  </Link>
                </div>
                <div className="social-login d-none">
                  <Link
                    to="#"
                    className="d-flex align-items-center justify-content-center input-block btn google-login w-100"
                  >
                    <span>
                      <ImageWithBasePath
                        src="assets/img/icons/facebook.svg"
                        className="img-fluid"
                        alt="Facebook"
                      />
                    </span>
                    Log in with Facebook
                  </Link>
                </div>
                {/* /Social Login */}
                <div className="text-center dont-have d-none">
                   <Link to={routes.register}>Register</Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

Login.propTypes = {
  message: PropTypes.any.isRequired,
  checkIfLoggedIn: PropTypes.any.isRequired,
};

export default Login;
